import type { ReactNode } from "react";

export function PanelShell({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-5 px-5 pb-7 pt-[18px]">
      <h3 className="font-display text-[15px] font-bold">{title}</h3>
      {children}
    </div>
  );
}
